/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";

// Redux
import { useSelector } from "react-redux";

import searchIco from "../../../../../../../../../../../../assets/images/manager-area/search.svg";
import filterGroupLogo from "../../../../../../../../../../../../assets/images/manager-area/filter-section-group.svg";

import "./TableHeaderDropdown.scss";

//i18n
import { withTranslation } from "react-i18next";

const index = ({
  t,
  searchFilterValueReceived,
  optionDefault,
  filterInputValue,
}) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  const [single, setSingle] = useState(false);

  const toggleDropdown = () => {
    setSingle(!single);
  };

  return (
    <Dropdown className="mr-3" isOpen={single} toggle={toggleDropdown}>
      <DropdownToggle
        className={`bg-table-header ${mainTheme === "dark" ? "dark" : "light"}`}
        caret
      >
        {optionDefault}
        <i className="mdi mdi-chevron-down"></i>
      </DropdownToggle>
      <DropdownMenu>
        <div className="dropdown-area m-2">
          <div className="d-flex m-3">
            <div className="mr-2">
              <img src={filterGroupLogo} alt="filter-group-logo" />
            </div>
            <div className="ml-3">
              <h5 className="filter-group-title">
                {t("Search by name in real time")}:
              </h5>
            </div>
          </div>

          <div className={`agent-search-name-area d-flex m-3 ${mainTheme === "dark" ? "dark" : "light"}`}>
            <img
              src={searchIco}
              className="ml-2"
              alt="search-icon-placeholder"
            />
            <input
              className={`agent-search-name-input my-2 p-2 ${mainTheme === "dark" ? "dark" : "light"}`}
              type="text"
              placeholder={t("Agent name...")}
              onChange={(e) => searchFilterValueReceived(e.target.value)}
              value={filterInputValue}
            />
          </div>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default withTranslation()(index);
